import React, { useEffect, useState, Fragment } from 'react'
import { compose } from 'recompose'
import { useTheme, Grid, Typography, Button, Paper, Box, Link, Checkbox, FormControlLabel } from '@material-ui/core'
import LoginPagesWrapper from '../../../components/LoginPagesWrapper'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import Stepper from '../../../components/StepperV2'
import { withRouter } from 'react-router'
import { autoSignIn, getTeamBackgroundByEmail, getTeamLogoByEmail, getOwnerMFAState, getIsRegistrationFinished, getCreatorInfoByEmail, getRegistrationStatus, setupPassword, registerUser, resetVerificationCodeCountDown, sendVerificationCode, getCreatorInfoByEncryptedLink, getCreatorInfoByEmailTemp, setEmailClickByMessageId, setEmailClickByPatientEmail } from '../../../redux/actions'
import { connect } from 'react-redux'
import FormTextField from '../../../components/FormTextField'
import { reduxForm, change, formValueSelector } from 'redux-form'
import { required, passwordMatch, passwordStrength, email } from '../../../utilties/validators'
import Logo from '../../../assets/logo'
import { injectIntl } from 'react-intl'
import queryString from 'query-string'
import makeStyles from '@material-ui/core/styles/makeStyles'
import translations from '../../../utilties/languages/locales'
import locale2 from 'locale2'
import { teamBackgroundIsLoadingSelector, teamBackgroundSelector, teamLogoIsLoadingSelector, teamLogoSelector, ownerMFAStateSelector, isRegistrationFinishedSelector, creatorInfoSelector, registrationStatusSelector, registrationIsSavingSelector, isVerificationCodeCountDownSelector, thirdPartyTermsSelector, termsSelector } from '../../../redux/selectors'
import defaultBackground from '../../../assets/images/default-bg.png'
import defaultLogo from '../../../assets/images/logo_benchmarc.svg'
import { CircularProgress } from '@material-ui/core'
import history from '../../../utilties/history'
import * as cookies from '../../../utilties/cookies'
import RegistrationPagesWrapper from '../../../components/RegistrationPagesWrapper'
import FormPassword from '../../../components/FormPassword'

const formName = 'register';
const requiredValidator = required
const emailValidator = email
const passwordStrengthValidator = passwordStrength
const passwordMatchValidator = passwordMatch('password')
const selector = formValueSelector(formName)


const getLocale = () => {
	let locale = 'en';
	let localeCookie = cookies.get('languageAbbreviation');

	if (localeCookie) {
		locale = localeCookie;
	}
	else if (locale2) {
		locale = locale2.substring(0, 5)
		if (locale !== 'en-GB') {
			locale = locale2.substring(0, 2)
		}
	}

	if (!translations[locale]) {
		locale = 'en'
	}

	return locale;
}

const useStyles = makeStyles((theme) => ({
	gridStyle: {
	  padding: '6rem',
	  width: '100%',
	  margin: '0',
	  boxSizing: 'border-box',
	  display: 'flex',
	  flexDirection: 'column',
	  alignItems: 'center',
	  [theme.breakpoints.down('sm')]: {
		padding: '3rem 2rem 5rem',
	  }
	},
}))

const Register = ({
	handleSubmit,
	intl,
	location,
	formChangeEmail,
	formChangeLanguage,
	register,
	setupPassword,
	email,
	language,
	teamBackground,
	loadTeamBackground,
	teamBackgroundIsLoading,
	teamLogo,
	teamLogoIsLoading,
	loadTeamLogo,
	autoSignIn,
    ownerMFAState,
	loadOwnerMFAState,
	isRegistrationFinished,
	checkIsRegistrationFinished,
    pristine,
    invalid,
	anyTouched,
	getCreatorInfo,
	creatorInfo,
	registrationStatus,
	getRegistrationStatus,
	isSaving,
	isCodeCountDown,
	resetCodeCountDown,
	sendVerificationCode,
	getCreatorInfoByLink,
	getCreatorInfoByEmailTemp,
	setEmailClickByMessageId,
	setEmailClickByPatientEmail
}) => {
	const classes = useStyles()
	const theme = useTheme()

	const [ canSend, setCanSend ] = useState(false)
	const [isRedirecting, setIsRedirecting] = useState(false)
	const [ secondsLeft, setSecondsLeft ] = useState(0)
	const [ timerId, setTimerId ] = useState(null)
	const [ canBack, setCanBack ] = useState(false)
    const [showCreatorInfoPanel, setShowCreatorInfoPanel] = useState(false)
	const [ showVerificationBlock, setShowVerificationBlock ] = useState(false)
	const [rememberMe, setRememberMe] = useState(true);
	const [ originalEmail, setOriginalEmail ] = useState()
	const [ disableEmailInput, setDisableEmailInput ] = useState(true)

	useEffect(() => {
		const values = queryString.parse(location.search)

		if (values.email) {
			setOriginalEmail(values.email)

			if (!values.email.match(/^patient\+\d{1,}@incytesapp\.co$/)) {
				formChangeEmail(values.email)
			} else {
				setDisableEmailInput(false)
			}
		}

		formChangeLanguage(getLocale())

		setCanBack(!!values.data)

		if(values.data) {
			getCreatorInfoByLink(values.data)
		}
	}, [])

	useEffect(() => {
		const values = queryString.parse(location.search)
		
		if(values.patient && values.token) {
			if(values.messageId) {
				setEmailClickByMessageId(values.messageId)
			} else {
				setEmailClickByPatientEmail(values.email, values.token)
			}
			
			autoSignIn(values.patient, values.token)
			setIsRedirecting(true)
		}
		else {
			setIsRedirecting(false)
		}

	}, [location.search])

	useEffect(() => {
		if (originalEmail) {
			setShowCreatorInfoPanel(true)
			loadTeamBackground(originalEmail)
			loadTeamLogo(originalEmail)
			loadOwnerMFAState(originalEmail)
			checkIsRegistrationFinished(originalEmail)

			var trimmedEmail = originalEmail.trim()
			if (trimmedEmail != originalEmail) {
				setOriginalEmail(trimmedEmail)
			}

			const values = queryString.parse(location.search)
			if (values.token) {
				getCreatorInfo(originalEmail, values.token)
			} else {
				getCreatorInfoByEmailTemp(originalEmail)
			}
		}
	}, [originalEmail])

	useEffect(() => {
		if (email) {
			var trimmedEmail = email.trim()
			if (trimmedEmail != email) {
				formChangeEmail(trimmedEmail)
			}
		}
	}, [email])

	useEffect(() => {
		if (originalEmail) {
			const query = queryString.parse(location.search)
			
			if(!query.patient) {
				getRegistrationStatus(originalEmail, query.token)
			}
		}
	}, [originalEmail, location.search])

	useEffect(
		() => {
			if (!!isRegistrationFinished) {
				const query = queryString.parse(location.search)

				if (!query.patient) {
					history.push("/")
				}
			}
		},
		[isRegistrationFinished]
	)

	useEffect(
		() => {
			setCanSend(registrationStatus == 2)
			if (!showVerificationBlock && registrationStatus == 2) {
				setShowVerificationBlock(true)
			}
		},
		[registrationStatus]
	)

	useEffect(
		() => {
			if (!!isCodeCountDown) {
				var curSec = 60
				setSecondsLeft(curSec)
				var intervalId = setInterval(
					() => {
						if (curSec > 0) {
							curSec--
							setSecondsLeft(curSec)
						}
					},
					1000
				)
				setTimerId(intervalId)
			}
		},
		[isCodeCountDown]
	)

	useEffect(
		() => {
			if (secondsLeft === 0 && !!isCodeCountDown) {
				clearInterval(timerId)
				setTimerId(null)
				resetCodeCountDown()
			}
		},
		[secondsLeft]
	)


	const onSendVerificationCode = () => {
		if (
			registrationStatus == 2
			&& secondsLeft <= 0
		) {
			sendVerificationCode(email, language)
		}
	}

	const onGoBack = () => {
		if (canBack) {
			const query = queryString.parse(location.search)

			history.push(`/auth/emailVerification?data=${query.data}`)
		}
	}

	const onSubmitForm = (values) => {
		if (pristine || invalid || isSaving || registrationStatus === 0 || isCodeCountDown == null) {
			return
		}

		const query = queryString.parse(location.search)
		if (query.token?.length > 0) {
			register(values.email, values.password, rememberMe, values.language, query.token, originalEmail)
		}
		else {
			setupPassword(values.verificationCode, values.email, values.password, rememberMe, values.language) 
		}
	}

	const inviterText = () => {
		return creatorInfo
			? creatorInfo.teamName || `${creatorInfo.firstName} ${creatorInfo.lastName}${creatorInfo.credentials ? ', ' + creatorInfo.credentials : ''}`
			: ''
	}

	const handleRememberMeChange = event => {
        setRememberMe(event.target.checked);
    };

	return (
		<Fragment>
			{
				isRedirecting
					? <div style={{ height: '100vh', backgroundColor: 'white' }}><CircularProgress style={{ position: 'absolute', top: '50%', left: '50%' }} /></div>
					: <LoginPagesWrapper
						logoUrl={teamLogo || !teamLogoIsLoading && defaultLogo}
						backgroundUrl={teamBackground || !teamBackgroundIsLoading && defaultBackground}
						canChangeLanguage={false}
					>
						<RegistrationPagesWrapper
							showCreatorInfoPanel={true}
						>
							<form onSubmit={handleSubmit(onSubmitForm)}
								data-testid='form-register'
								style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
								<Paper className={classes.gridStyle} elevation={2}>
									<Grid item style={{ paddingBottom: '20px', textAlign: 'center' }}>
										<Logo />
									</Grid>
									{
										creatorInfo
										&& <Fragment>
											<Grid item xs={12} style={{ paddingBottom: '20px', textAlign: 'center' }}>
												<Typography variant='h3' style={{ fontWeight: '500' }}>{intl.formatMessage({ id: 'app.register.title' }).replace('%%TeamName%%', inviterText()).replace('%%Protocol%%', creatorInfo.protocolName)}</Typography>
											</Grid>
											{
												registrationStatus == 3
												&& <Grid item xs={12} sm={10} style={{ paddingBottom: '40px', paddingTop: '10px' }}>
													<Typography align='center'>
														{intl.formatMessage({ id: 'app.register.paragraph' })}
													</Typography>
												</Grid>
											}
										</Fragment>
									}
									<Grid item xs={12} sm={10} style={{ width: '100%' }}>
										<FormTextField
											data-testid='form-register-input-email'
											label={intl.formatMessage({ id: 'app.email' })}
											fullWidth
											disabled={disableEmailInput}
											type='text'
											name='email'
											validators={[requiredValidator, emailValidator]}
											variant='filled'
										/>
									</Grid>
									{
										!!showVerificationBlock
										&& <Fragment>
											<Grid item xs={12} style={{ paddingBottom: '10px', textAlign: 'center' }}>
												<Typography variant='body2'>
													{intl.formatMessage({ id: 'app.accessCode.codeSent' })}
												</Typography>
											</Grid>
											<Grid item xs={12} sm={10} style={{ width: '100%' }}>
												<FormTextField
													data-testid='form-register-input-access-code'
													label={intl.formatMessage({ id: 'app.accessCode.label' })}
													fullWidth
													disabled={!registrationStatus}
													name='verificationCode'
													type="number"
													validators={[requiredValidator]}
													variant='filled'
													maxLength={null}
													inputProps={{
														max: 999999
													}}
												/>
											</Grid>
										</Fragment>
									}
									{
										registrationStatus == 2
										&& isCodeCountDown != null
										&& secondsLeft === 0
										&& <Grid
											item
											container
											xs={12}
											sm={10}
											justifyContent="center"
											style={{
												width: '100%'
											}}
										>
											<Grid item>
												<Typography variant='caption'>
													<Box
														onClick={(e) => e.preventDefault()}
													>
														{intl.formatMessage({ id: 'app.accessCode.didntReceive' })}
														{' '}
														<Link
															data-testid="form-verify-button"
															href="#"
															disabled={secondsLeft > 0 || !canSend}
															onClick={onSendVerificationCode}
														>
															{intl.formatMessage({ id: 'app.accessCode.resend' })}
														</Link>
													</Box>
												</Typography>
											</Grid>
										</Grid>
									}
									{
										isCodeCountDown == null
										&& <Grid
											item
											container
											justifyContent="center"
											alignItems="center"
											spacing={3}
										>
											<Grid item>
												<CircularProgress size={25} />
											</Grid>
											<Grid item>
												<Typography variant='h3'>
													{intl.formatMessage({ id: 'app.accessCode.sending...' })}
												</Typography>
											</Grid>
										</Grid>
									}
									{
										secondsLeft > 0
										&& <Grid item xs={12} sm={10} style={{ width: '100%' }}>
											<Typography variant='caption'>
												{intl.formatMessage({ id: 'app.accessCode.countdown' }, { countdown: secondsLeft })}
											</Typography>
										</Grid>
									}
									<Grid item xs={12} sm={10} style={{ width: '100%', paddingTop: '20px' }}>
										<Typography variant='caption'>
											{intl.formatMessage({ id: 'app.passwordRequirements' })}
										</Typography>
									</Grid>
									<Grid item xs={12} sm={10} style={{ width: '100%' }}>
										<FormPassword
											data-testid='form-register-input-password'
											label={intl.formatMessage({ id: 'app.password' })}
											fullWidth
											name='password'
											validators={[requiredValidator, passwordStrengthValidator]}
											variant='filled'
											maxLength={99}
										/>
									</Grid>
									<Grid item xs={12} sm={10} style={{ width: '100%' }}>
										<FormPassword
											data-testid='form-register-input-reenter'
											label={intl.formatMessage({ id: 'app.confirmPassword' })}
											fullWidth
											name='confirmPassword'
											validators={[required, passwordMatchValidator]}
											variant='filled'
											maxLength={99}
										/>
									</Grid>
									<Grid item xs={12} sm={10} style={{ width: '100%', margin: '15px 0 40px' }}>
										<FormControlLabel
											control={
												<Checkbox
													data-testid="form-login-checkbox-keep-signed"
													onChange={handleRememberMeChange}
													checked={rememberMe}
													color="primary"
												/>
											}
											label={
                            		            <Grid data-testid="form-login-keep-label">
													<div style={{ fontSize: '12px' }}>
														{intl.formatMessage({ id: 'app.keepMeSignedIn.label' })}
													</div>
													<div style={{ fontSize: '12px' }}>
														{intl.formatMessage({ id: 'app.keepMeSignedIn.message' })}
													</div>
												</Grid>
											}
										/>
									</Grid>
									<div
										className="stepper-register-wrapper">
										<div className="stepper-register-next">
											{!isSaving
												? <Button
													data-testid="form-next-button"
													type='submit'
													variant='contained'
													color='primary'
													size='small'
													disabled={pristine || invalid || isSaving || registrationStatus === 0 || isCodeCountDown == null}
													endIcon={<KeyboardArrowRight />}													
												>
													{intl.formatMessage({ id: 'app.general.next' })}
												</Button>
												: <div style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingTop: '10px' }}><CircularProgress size={24} /></div>
											}
										</div>											

										<div className="stepper-register-step">
											<Stepper stepsCount={3 + (ownerMFAState ? 1 : 0)} selectedStep={1} stepNumber={1} />
										</div>

										<div className="stepper-register-back">
											{
												registrationStatus == 2
												&& canBack
												&& <Button
													data-testid="form-back-button"
													variant='outlined'
													color='primary'
													size='small'
													disabled={registrationStatus != 2}
													startIcon={<KeyboardArrowLeft />}													
													onClick={onGoBack}
												>
													{intl.formatMessage({ id: 'app.general.back' })}
												</Button>
											}
										</div>
									</div>
								</Paper>
							</form>
						</RegistrationPagesWrapper>
					</LoginPagesWrapper>
			}
		</Fragment>
	)
}

const mapStateToProps = (state) => ({
	failed: state.auth.failedLogin,
	email: selector(state, 'email'),
	language: selector(state, 'language'),
	teamBackground: teamBackgroundSelector(state),
	teamBackgroundIsLoading: teamBackgroundIsLoadingSelector(state),
    teamLogo: teamLogoSelector(state),
	teamLogoIsLoading: teamLogoIsLoadingSelector(state),
	ownerMFAState: ownerMFAStateSelector(state),
	isRegistrationFinished: isRegistrationFinishedSelector(state),
	creatorInfo: creatorInfoSelector(state),
	isSaving: registrationIsSavingSelector(state),
	registrationStatus: registrationStatusSelector(state),
	isCodeCountDown: isVerificationCodeCountDownSelector(state),
	internalTerms: termsSelector(state),
	thirdPartyTerms: thirdPartyTermsSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
	formChangeEmail: (email) => dispatch(change(formName, 'email', email)),
	formChangeLanguage: (language) => dispatch(change(formName, 'language', language)),
	register: (email, password, rememberMe, language, token, originalEmail) => dispatch(
		registerUser(email, password, rememberMe, language, token, originalEmail)
	),
	setupPassword: (verificationCode, email, password, rememberMe, language) => dispatch(
		setupPassword(verificationCode, email, password, rememberMe, language)
	),
	loadTeamBackground: (email) => dispatch(getTeamBackgroundByEmail(email)),
	loadTeamLogo: (email) => dispatch(getTeamLogoByEmail(email)),
	autoSignIn: (data, token) => dispatch(autoSignIn(data, token)),
	loadOwnerMFAState: (email) => dispatch(getOwnerMFAState(null, email)),
	checkIsRegistrationFinished: (email) => dispatch(getIsRegistrationFinished(email)),
	getCreatorInfo: (email, token) => dispatch(getCreatorInfoByEmail(email, token)),
	getRegistrationStatus: (email, token) => dispatch(getRegistrationStatus(email, token)),
	resetCodeCountDown: () => dispatch(resetVerificationCodeCountDown()),
	sendVerificationCode: (email, language) => dispatch(sendVerificationCode(email, language)),
	getCreatorInfoByLink: (data) => dispatch(getCreatorInfoByEncryptedLink(data)),
	getCreatorInfoByEmailTemp: (email) => dispatch(getCreatorInfoByEmailTemp(email)),
	setEmailClickByMessageId: (messageId) => dispatch(setEmailClickByMessageId(messageId)),
	setEmailClickByPatientEmail: (email, token) => dispatch(setEmailClickByPatientEmail(email, token)),
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	reduxForm({
		form: formName
	}),
	withRouter
)

export default enhance(Register)
